import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'filterExactArray'
})

export class FilterExactArrayPipe implements PipeTransform {

    transform(items: any[], searchText: string, property): any[] {

        if (searchText === '') {
            return items;
        }

        searchText = searchText.toLowerCase();


        return items = _.filter(items, (obj) => {
            return obj[property].toLowerCase() == searchText;
        });
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/filterExactMatch.pipe.ts